<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <base-crud
          :ref="'transportesCrud'"
          crudName="Solicitações"
          newText="Nova Solicitação"
          :table="table"
          :columns="columns"
          :options="options"
          :endPoint="endPoint"
          :enableAdd="true"
          :enableEdit="true"
          :enableDelete="false"
          :enableView="false"
          :enableReset="false"
          :dataForm="dataForm"
          :customFilters="customFilters"
          :extra="extra"
          @view="view"
          @filtered_ds="filtered_ds"
          @filtered_dp="filtered_dp"
        >
        </base-crud>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../../layouts/Base/BaseCrud";

export default {
  data: function () {
    return {
      customFilters: [
        {
          name: "data_solicitacao_f",
          type: "calendar",
          call: "filtered_ds",
        },
        {
          name: "data_procedimento_f",
          type: "calendar",
          call: "filtered_dp",
        },
      ],
      data_solicitacao: "",
      table: "solicitacoesTable",
      showMessageImport: false,
      usersCrud: {},
      pages: [],
      url: "",
      columns: [
        "transporte_sanitario_id",
        "data_solicitacao_f",
        "data_procedimento_f",
        "tipo_transporte_id",
        "paciente_id",
        "status_solicitacao",
        "actions",
      ],
      tableData: [
        "transporte_sanitario_id",
        "data_solicitacao",
        "data_procedimento",
        "unidade_saude_id",
        "tipo_transporte_id",
        "paciente_id",
        "status_solicitacao",
      ],
      options: {
        filterByColumn: true,
        debounce: 1000,
        sortIcon: {
          base: "fas",
          up: "fa-chevron-up",
          down: "fa-chevron-down",
          is: "fa-sort",
        },
        sortable: [
          "transporte_sanitario_id",
          "data_solicitacao",
          "data_procedimento",
          "tipo_transporte_id",
          "paciente_id",
          "status_solicitacao",
        ],
        filterable: [
          "transporte_sanitario_id",
          "paciente_id",
          "tipo_transporte_id",
          "status_solicitacao",
        ],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          transporte_sanitario_id: "ID Transporte",
          data_solicitacao_f: "Data da Solicitação",
          data_procedimento_f: "Data do Transporte",
          unidade_saude_id: "Unidade solicitante",
          tipo_transporte_id: "Tipo de transporte",
          paciente_id: "Nome Paciente",
          status_solicitacao: "Status",
          actions: "Ações",
        },

        texts: {
          filterBy: "Filtrar",
          defaultOption: "Selecione",
        },
        listColumns: {
          status_solicitacao: [
            {
              id: 0,
              text: "Solicitado",
            },
            {
              id: 1,
              text: "Aprovado",
            },
            {
              id: 2,
              text: "Programado",
            },
            {
              id: 3,
              text: "Finalizado",
            },
            {
              id: 4,
              text: "Cancelado",
            },
          ],
        },
        templates: {
          tipo_transporte_id: function (h, row, index) {
            return row.tipo_transporte.tipo_transporte_nome;
          },
          paciente_id: function (h, row, index) {
            return row.paciente ? row.paciente.nome_paciente : "NÃO SE APLICA";
          },
          profissional_id: function (h, row, index) {
            return row.profissional.profissional_nome;
          },
          status_solicitacao: function (h, row, index) {
            if (row.status_solicitacao == 0) {
              return (
                <h5>
                  <span class="badge badge-warning">Solicitado</span>
                </h5>
              );
            }
            if (row.status_solicitacao == 1) {
              return (
                <h5>
                  <span class="badge badge-info">Aprovado</span>
                </h5>
              );
            }
            if (row.status_solicitacao == 2) {
              return (
                <h5>
                  <span class="badge badge-primary">Programado</span>
                </h5>
              );
            }
            if (row.status_solicitacao == 3) {
              return (
                <h5>
                  <span class="badge badge-success">Finalizado</span>
                </h5>
              );
            }
            if (row.status_solicitacao == 4) {
              return (
                <h5>
                  <span class="badge badge-danger">Cancelado</span>
                </h5>
              );
            }
          },
        },
        requestFunction: function (data) {
          let requestData = {};

          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;

          if (
            this.$parent.$parent.$parent.data_procedimento != null &&
            this.$parent.$parent.$parent.data_procedimento != ""
          ) {
            requestData.params.data_procedimento =
              this.$parent.$parent.$parent.data_procedimento;
          }

          if (
            this.$parent.$parent.$parent.data_solicitacao != null &&
            this.$parent.$parent.$parent.data_solicitacao != ""
          ) {
            requestData.params.data_solicitacao =
              this.$parent.$parent.$parent.data_solicitacao;
          }

          requestData.params.query = "";
          requestData.params.with = [
            "paciente",
            "profissional",
            "tipo_transporte",
            "solicitante",
          ];

          return axios.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      extra: [
        {
          id: 1,
          label: "",
          class: "ml-1 btn btn-crud view",
          title: "Visualizar",
          name: "view",
          icon: "fas fa-eye",
        },
      ],
      endPoint: "solicitacoes",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  methods: {
    filtered_dp(date) {
      this.data_procedimento = date;
    },
    filtered_ds(date) {
      this.data_solicitacao = date;
    },
    view(props, row, index) {
      const self = this;
      this.$router.push("/aprovacoes/aprovacao/" + props.row.id);
    },
    makeFormData: function () {
      const self = this;
      let fd = new FormData();

      let fileImport = document.getElementById("fileImport");

      fd.append("fileImport", fileImport.files[0] ? fileImport.files[0] : "");

      return fd;
    },

    query: function (query) {
      let columns = {
        transporte_sanitario_id: "transporte_sanitario_id",
        data_solicitacao: "data_solicitacao",
        tipo_transporte_id: "tipo_transporte[tipo_transporte_nome]",
        paciente_id: "paciente[nome_paciente]",
        status_solicitacao: "status_solicitacao",
      };
      let filters =
        "orderByDesc=transporte_sanitario_id&duplicado_recorrencia=0&";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
    openInput() {
      document.getElementById("fileImport").click();
    },
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
.uploading-image {
  display: flex;
  border-radius: 10px;
  width: 100px;
  height: 100px;
}
</style>